export const ADMIN_ROUTES = {
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_LEADS: '/admin/leads',
  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_ACCOUNTS: '/admin/accounts',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_SUPPORTS: '/admin/supports',
  ADMIN_IB_MARKETING: '/admin/ib-marketing',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_PROFILE: '/admin/profile',
  ADMIN_TRADES: '/admin/trades',
  ADMIN_ECONOMIC_CALENDAR: '/admin/calendar',

  ADMIN_TRADING_SERVICES_OVERVIEW: '/admin/trading-services/overview',

  ADMIN_PAMM_DASHBOARD: '/admin/trading-services/pamm/dashboard',
  ADMIN_PAMM_ACCOUNTS: '/admin/trading-services/pamm/accounts',
  ADMIN_PAMM_STRATEGIES: '/admin/trading-services/pamm/strategies',
  ADMIN_PAMM_INVESTORS: '/admin/trading-services/pamm/investors',
  ADMIN_PAMM_PERFORMANCE: '/admin/trading-services/pamm/performance',
  ADMIN_PAMM_ALLOCATIONS: '/admin/trading-services/pamm/allocations',
  ADMIN_PAMM_COMMISSIONS: '/admin/trading-services/pamm/commissions',
  ADMIN_PAMM_TRADES: '/admin/trading-services/pamm/trades',
  ADMIN_PAMM_APPROVALS: '/admin/trading-services/pamm/approvals',
  ADMIN_PAMM_REPORTS: '/admin/trading-services/pamm/reports',

  ADMIN_MAM_DASHBOARD: '/admin/trading-services/mam/dashboard',
  ADMIN_MAM_ACCOUNTS: '/admin/trading-services/mam/accounts',
  ADMIN_MAM_MANAGERS: '/admin/trading-services/mam/managers',
  ADMIN_MAM_INVESTORS: '/admin/trading-services/mam/investors',
  ADMIN_MAM_PERFORMANCE: '/admin/trading-services/mam/performance',
  ADMIN_MAM_ALLOCATIONS: '/admin/trading-services/mam/allocations',
  ADMIN_MAM_COMMISSIONS: '/admin/trading-services/mam/commissions',
  ADMIN_MAM_TRADES: '/admin/trading-services/mam/trades',
  ADMIN_MAM_SETTINGS: '/admin/trading-services/mam/settings',
  ADMIN_MAM_REPORTS: '/admin/trading-services/mam/reports',

  ADMIN_COPY_TRADING_DASHBOARD:
    '/admin/trading-services/copy-trading/dashboard',
  ADMIN_COPY_TRADING_STRATEGIES:
    '/admin/trading-services/copy-trading/strategies',
  ADMIN_COPY_TRADING_MANAGERS: '/admin/trading-services/copy-trading/managers',
  ADMIN_COPY_TRADING_FOLLOWERS:
    '/admin/trading-services/copy-trading/followers',
  ADMIN_COPY_TRADING_PERFORMANCE:
    '/admin/trading-services/copy-trading/performance',
  ADMIN_COPY_TRADING_TRADES: '/admin/trading-services/copy-trading/trades',
  ADMIN_COPY_TRADING_SETTINGS: '/admin/trading-services/copy-trading/settings',
  ADMIN_COPY_TRADING_REPORTS: '/admin/trading-services/copy-trading/reports',

  ADMIN_STRATEGY_APPROVAL: '/admin/trading-services/strategy-approval',
  ADMIN_PAMM_APPROVAL: '/admin/trading-services/pamm-approval',
  ADMIN_RISK_MONITORING: '/admin/trading-services/risk-monitoring',
  ADMIN_AUDIT_LOGS: '/admin/trading-services/audit-logs',
  ADMIN_TRADING_PERFORMANCE: '/admin/trading-services/performance',
  ADMIN_TRADING_TRADE_HISTORY: '/admin/trading-services/trade-history',
  ADMIN_TRADING_FEES: '/admin/trading-services/fees',
  ADMIN_TRADING_REPORTS: '/admin/trading-services/reports',
};

export const USER_ROUTES = {
  USER_DASHBOARD: '/dashboard',
  USER_WALLET: '/wallet',
  USER_KYC: '/kyc',
  USER_ACCOUNTS: '/accounts',
  USER_ACCOUNT_DEMO: '/accounts/demo',
  USER_ACCOUNT_LIVE: '/accounts/live',
  USER_ACCOUNT_LEVERAGE_HISTORY: '/accounts/leverage-history',
  USER_ACCOUNT_MY_TRADES: '/accounts/my-trades',
  USER_ORDER_HISTORY: '/order-history',
  USER_PAYMENTS: '/payments',
  USER_DEPOSIT: '/payments/deposit',
  USER_WITHDRAWAL: '/payments/withdrawal',
  USER_TRANSFER: '/payments/transfer',
  USER_SUPPORTS: '/supports',
  USER_ANALYTICS: '/analytics',
  USER_IB_ACCOUNTS: '/ib-accounts',
  USER_FAQ: '/faq',
  USER_QUICK_LINKS: '/quick-links',
  USER_WEB_TERMINAL: '/web-terminal',
  USER_PROFILE: '/profile',
  USER_SETTINGS: '/settings',
  USER_ECONOMIC_CALENDAR: '/calendar',
  USER_MT5_DASHBOARD: '/mt5/dashboard',
  USER_MT5_TRADING: '/mt5/trading',
  USER_MT5_POSITIONS: '/mt5/positions',
  USER_MT5_HISTORY: '/mt5/history',

  USER_TRADING_SERVICES_OVERVIEW: '/trading-services/overview',
  USER_PAMM_DASHBOARD: '/trading-services/pamm/dashboard',
  USER_PAMM_INVESTMENTS: '/trading-services/pamm/investments',
  USER_PAMM_MARKETPLACE: '/trading-services/pamm/marketplace',
  USER_PAMM_FUNDS: '/trading-services/pamm/funds',
  USER_PAMM_FUND_DETAILS: '/trading-services/pamm/funds/:id',
  USER_PAMM_INVESTOR: '/trading-services/pamm/investor/:id',
  USER_PAMM_PORTFOLIO: '/trading-services/pamm/portfolio',
  USER_PAMM_PROFIT_LOSS: '/trading-services/pamm/profit-loss',
  USER_PAMM_DEPOSIT_HISTORY: '/trading-services/pamm/deposit-history',
  USER_PAMM_TRADING_HISTORY: '/trading-services/pamm/trading-history',
  USER_PAMM_SUBSCRIPTIONS: '/trading-services/pamm/subscriptions',
  USER_PAMM_SETTINGS: '/trading-services/pamm/settings',
  USER_PAMM_MANAGER_DASHBOARD: '/trading-services/pamm/manager-dashboard',

  USER_MAM_DASHBOARD: '/trading-services/mam/dashboard',
  USER_MAM_ACCOUNTS: '/trading-services/mam/accounts',
  USER_MAM_GROUPS: '/trading-services/mam/groups',
  USER_MAM_GROUP_DETAILS: '/trading-services/mam/groups/:id',
  USER_MAM_ALLOCATION_RULES: '/trading-services/mam/allocation-rules',
  USER_MAM_PORTFOLIO: '/trading-services/mam/portfolio',
  USER_MAM_PROFIT_LOSS: '/trading-services/mam/profit-loss',
  USER_MAM_DEPOSIT_HISTORY: '/trading-services/mam/deposit-history',
  USER_MAM_TRADING_HISTORY: '/trading-services/mam/trading-history',
  USER_MAM_SUBSCRIPTIONS: '/trading-services/mam/subscriptions',

  USER_COPY_TRADING_DASHBOARD: '/trading-services/copy-trading/dashboard',
  USER_COPY_TRADING_MARKETPLACE: '/trading-services/copy-trading/marketplace',
  USER_COPY_TRADING_STRATEGY_DETAILS:
    '/trading-services/copy-trading/strategy/:id',
  USER_COPY_TRADING_PROVIDER_DASHBOARD:
    '/trading-services/copy-trading/provider-dashboard',
  USER_COPY_TRADING_PORTFOLIO: '/trading-services/copy-trading/portfolio',
  USER_COPY_TRADING_ACTIVE: '/trading-services/copy-trading/my-copies',
  USER_COPY_TRADING_HISTORY: '/trading-services/copy-trading/trading-history',
  USER_COPY_TRADING_EARNINGS: '/trading-services/copy-trading/profit-loss',
  USER_COPY_TRADING_SETTINGS: '/trading-services/copy-trading/settings',
  USER_COPY_TRADING_LIVE_TRADES: '/trading-services/copy-trading/live-trades',
  USER_COPY_TRADING_RISK: '/trading-services/copy-trading/risk-management',

  USER_TRADING_PERFORMANCE: '/trading-services/performance',
  USER_TRADING_TRADE_HISTORY: '/trading-services/trade-history',
  USER_TRADING_FEES: '/trading-services/fees',
  USER_TRADING_REPORTS: '/trading-services/reports',
  USER_TRADING_STATEMENTS: '/trading-services/statements',
};

export const IB_ROUTES = {
  USER_IB_DASHBOARD: '/ib/dashboard',
  USER_IB_LIST: '/ib/ib-list',
  USER_IB_ACCOUNTS: '/ib-accounts',
  USER_IB_CLIENTS: '/ib/clients',
  USER_IB_COMMISSIONS: '/ib/commissions',
  USER_IB_WALLET: '/ib/wallet',
  USER_IB_REBATES: '/ib/rebates',
  USER_IB_REPORTS: '/ib/reports',
  USER_IB_MARKETING_TOOLS: '/ib/marketing-tools',
  USER_IB_KYC: '/ib/kyc',
  USER_IB_SETTINGS: '/ib/settings',
};

export const PUBLIC_ROUTES = {
  LOGIN: '/login',
  // REGISTER: '/register',
  SIGNUP: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
};

export const PAMM_ROUTES = {
  PAMM_DASHBOARD: '/pamm/dashboard',
  PAMM_FUND_MANAGEMENT: '/pamm/funds',
  PAMM_CREATE_FUND: '/pamm/funds/create',
  PAMM_EDIT_FUND: '/pamm/funds/edit',
  PAMM_FUND_DETAILS: '/pamm/funds/details',
  PAMM_INVESTORS: '/pamm/investors',
  PAMM_INVESTOR_DETAILS: '/pamm/investors/details',
  PAMM_INVESTMENT_REQUESTS: '/pamm/investment-requests',
  PAMM_DEPOSITS: '/pamm/deposits',
  PAMM_WITHDRAWALS: '/pamm/withdrawals',
  PAMM_PROFIT_DISTRIBUTION: '/pamm/profit-distribution',
  PAMM_ALLOCATION_HISTORY: '/pamm/allocation-history',
  PAMM_OPEN_TRADES: '/pamm/open-trades',
  PAMM_CLOSED_TRADES: '/pamm/closed-trades',
  PAMM_PERFORMANCE: '/pamm/performance',
  PAMM_FEES_COMMISSION: '/pamm/fees-commission',
  PAMM_REPORTS: '/pamm/reports',
  PAMM_STATEMENTS: '/pamm/statements',
};

export const MAM_ROUTES = {
  MAM_DASHBOARD: '/mam/dashboard',
  MAM_MANAGERS: '/mam/managers',
  MAM_CREATE_MANAGER: '/mam/managers/create',
  MAM_MANAGER_DETAILS: '/mam/managers/details',
  MAM_CLIENT_ACCOUNTS: '/mam/client-accounts',
  MAM_ALLOCATION: '/mam/allocation',
  MAM_TRADES: '/mam/trades',

  MAM_GROUPS: '/mam/allocation',
  MAM_GROUP_DETAILS: '/mam/allocation',
  MAM_ALLOCATION_RULES: '/mam/allocation',
  MAM_TRADE_ALLOCATION: '/mam/allocation',
  MAM_TRADE_MONITOR: '/mam/trades',
  MAM_OPEN_TRADES: '/mam/trades',
  MAM_CLOSED_TRADES: '/mam/trades',
  MAM_PERFORMANCE: '/mam/dashboard',
  MAM_COMMISSION: '/mam/dashboard',
  MAM_RISK_MANAGEMENT: '/mam/dashboard',
  MAM_REPORTS: '/mam/dashboard',
  MAM_AUDIT_LOGS: '/mam/dashboard',
};
